import {
    DASHBOARD_LITE_MODELS_ACTION_TYPES,
    DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES,
} from '@constants/actionTypes/dashboardLiteActionTypes';

interface IPartnerBroker {
    [key: string]: unknown;
}

interface IDashboardModels {
    [key: string]: unknown;
}

interface IFetchPartnerBrokerStartAction {
    type: typeof DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_START;
}

interface IFetchPartnerBrokerSuccessAction {
    type: typeof DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_SUCCESS;
    payload: IPartnerBroker;
}

interface IFetchPartnerBrokerFailAction {
    type: typeof DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_FAIL;
    payload: Error | string;
}

interface IFetchDashboardModelsStartAction {
    type: typeof DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_START;
}

interface IFetchDashboardModelsSuccessAction {
    type: typeof DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_SUCCESS;
    payload: IDashboardModels;
}

interface IFetchDashboardModelsFailAction {
    type: typeof DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_FAIL;
    payload: Error | string;
}

export type DashboardLiteAction =
    | IFetchPartnerBrokerStartAction
    | IFetchPartnerBrokerSuccessAction
    | IFetchPartnerBrokerFailAction
    | IFetchDashboardModelsStartAction
    | IFetchDashboardModelsSuccessAction
    | IFetchDashboardModelsFailAction;

export const fetchPartnerBrokerStart = (): IFetchPartnerBrokerStartAction => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_START,
});

export const fetchPartnerBrokerSuccess = (partnerBroker: IPartnerBroker): IFetchPartnerBrokerSuccessAction => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_SUCCESS,
    payload: partnerBroker,
});

export const fetchPartnerBrokerFail = (error: Error | string): IFetchPartnerBrokerFailAction => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_FAIL,
    payload: error,
});

export const fetchDashboardModelsLiteStart = (): IFetchDashboardModelsStartAction => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_START,
});

export const fetchDashboardModelsLiteSuccess = (dashboardModels: IDashboardModels): IFetchDashboardModelsSuccessAction => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_SUCCESS,
    payload: dashboardModels,
});

export const fetchDashboardModelsLiteFail = (error: Error | string): IFetchDashboardModelsFailAction => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_FAIL,
    payload: error,
});
